import { Skeleton } from 'antd';
import React, { memo } from 'react';
import styled from 'styled-components';

type SelectionListSkeletonProps = {
  rows?: number;
  type?: 'checkbox' | 'radio';
};
const SelectionListSkeleton = ({
  rows = 5,
  type = 'checkbox',
}: SelectionListSkeletonProps) => {
  const isRadio = type === 'radio';

  return (
    <Wrapper>
      {Array.from({ length: rows }).map((_, index) => (
        <Row key={index}>
          <Box>
            <ImgSkeleton active shape={isRadio ? 'circle' : 'square'} />
          </Box>
          <Text
            style={{
              width: `${60 + Math.random() * 40}%`,
            }}
          >
            <InputSkeleton active />
          </Text>
        </Row>
      ))}
    </Wrapper>
  );
};
export default memo(SelectionListSkeleton);
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const ImgSkeleton = styled(Skeleton.Avatar)`
  height: 100%;
  width: 100%;
  .ant-skeleton-avatar {
    height: 100%;
    width: 100%;
    border-radius: 4px;
  }
`;
const InputSkeleton = styled(Skeleton.Input)`
  width: 100%;
  .ant-skeleton-input {
    height: 18px;
    border-radius: 6px;
    min-width: 100% !important;
  }
`;
const Box = styled.div`
  min-width: 22px;
  min-height: 22px;
  width: 22px;
  height: 22px;
`;
const Text = styled.div``;
